export const NAME = 'MultiFlightTracker';
